//TODO:Do not remove code - To be implemented after webcam issue is resolve
import { memo, useCallback, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalHeader, BzModalTitle } from '../../components';
import { handleModal } from '../../redux/actions/modals';
import Webcam from 'react-webcam';
import { toastConfig } from '../../redux/actions/toast';

const videoContraints = {
    width: 400,
    height: 400,
    facingMode: 'user'
};

const WebCamModal = ({ onSubmitProfilePicture }) => {
    const dispatch = useDispatch();
    const webcamRef = useRef();

    const modals = useSelector(state => state?.modals?.modals);

    const [isCapturing, setIsCapturing] = useState(false);
    const [isWebcamReady, setIsWebcamReady] = useState(false);


    const onHide = () => {
        dispatch(handleModal([{ "PROFILE_WEB_CAM_MODAL": false }]));
    };

    const dataURLtoBlob = (dataurl) => {
        const arr = dataurl?.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) { u8arr[n] = bstr.charCodeAt(n); }
        return new Blob([u8arr], { type: mime });
    };


    // Memoize the captureScreenshot function
    const onCapture = useCallback(() => {
        if (isCapturing || !isWebcamReady) {
            // Prevent capture if already capturing or webcam is not ready
            return;
        }
        setIsCapturing(true); // Indicate that capturing has started
        // Access the screenshot from the webcam
        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
            // Handle the screenshot data
            afterScreenshot(imageSrc);
        } else {
            //Failed to capture screenshot
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Ooop!! Failed to capture screenshot, Please try again...` }));
        }

        // Reset capturing state
        setIsCapturing(false);
    }, [isCapturing, isWebcamReady]); // Dependencies for useCallback

    const onUserMedia = () => {
        setIsWebcamReady(true); // Set flag when webcam is ready
    };

    const afterScreenshot = (imgData) => {
        onSubmitProfilePicture(dataURLtoBlob(imgData));
        onHide();
    };

    return (
        <BzModal size='md' show={modals['PROFILE_WEB_CAM_MODAL']} onHide={onHide} id="TopModal" role="dialog" aria-hidden="true">
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <BzModalTitle className='font-medium font-size5 color-text'>Camera</BzModalTitle>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-center align-items-center'>
                            <Webcam
                                audio={false}
                                height={400}
                                width={400}
                                ref={webcamRef}
                                screenshotFormat='image/jpeg'
                                videoConstraints={videoContraints}
                                onUserMedia={onUserMedia}
                            />
                        </Col>
                    </Row>
                    <Row className='g-0 mt-3'>
                        <Col className='d-flex justify-content-end'>
                            <BzButton className='btn btn-md btn-outline btn-rounded' disabled={isCapturing || !isWebcamReady} onClick={() => onCapture()}>Capture</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal>
    );
};

export default memo(WebCamModal);